module.exports = __webpack_public_path__ + "static/media/Rapport_mémoire_SPR_Cadarache.621b2c2d.pdf";